import React, { useState, useEffect } from 'react';
import { SignIn } from "@clerk/clerk-react";
import logo from "../../images/logo.png";
import BlockchainBackground from "../../Components/BlockchainBackground";
import "../../styles/BlockchainBackground.css";

function SigninPage() {
  const [loading, setLoading] = useState(true);
  const [logoSize, setLogoSize] = useState('h-36');

  useEffect(() => {
    const resizeLogo = () => {
      const width = window.innerWidth;
      if (width < 640) {
        setLogoSize('h-20');
      } else {
        setLogoSize('h-24');
      }
    };

    resizeLogo();
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    window.addEventListener("resize", resizeLogo);
    return () => {
      window.removeEventListener("resize", resizeLogo);
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className="min-h-screen w-full flex flex-col bgColor font-[Montserrat] overflow-hidden relative">
      
      {/* Background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
        <BlockchainBackground />
      </div>

      {/* MContent */}
      <div className="flex-1 flex items-center justify-center z-10 px-4 sm:px-6 lg:px-8">
        <div
          className={`w-full max-w-md transition-opacity duration-1000 ease-in-out ${
            loading ? 'opacity-0' : 'opacity-100'
          }`}
        >
          <div className="w-full bg-[#154c79] bg-opacity-10 backdrop-blur-sm px-4 sm:px-6 py-8 rounded-2xl shadow-xl border border-white border-opacity-20">
            
            {/* Logo */}
            <div className="flex justify-center mb-6">
              <img 
                src={logo} 
                alt="BlockBallot Logo" 
                className={`transition-all duration-1000 ease-in-out ${logoSize} drop-shadow-md hover:scale-105`}
              />
            </div>

            {/* Clerk SignIn */}
            <SignIn
              appearance={{
                elements: {
                  card: "shadow-none bg-white bg-opacity-50 backdrop-blur-sm",
                  headerTitle: "text-xl font-semibold text-blue-950",
                  headerSubtitle: "text-blue-900",
                  formButtonPrimary: "block mx-auto w-2/3 text-center px-4 py-2 text-base font-medium text-white bg-[#154c79] rounded-full transition-all duration-300 ease-in-out hover:translate-y-[-2px] hover:shadow-lg shadow-md hover:bg-[#0d3656] flex items-center justify-center",
                  formFieldLabel: "text-blue-900",
                  formFieldInput: "border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
                  footerActionLink: "text-[#154c79] hover:text-blue-700",
                  identityPreviewText: "text-blue-900",
                  identityPreviewEditButtonIcon: "text-[#154c79]",
                  formFieldAction: "text-[#154c79] hover:text-blue-700",
                  formResendCodeLink: "text-[#154c79] hover:text-blue-700",
                  logoBox: "hidden",
                  socialButtonsIconButton: "hover:scale-105 transition-transform",
                  socialButtonsBlockButton: "hover:scale-105 transition-transform",
                  footerAction: "mt-4"
                },
                layout: {
                  socialButtonsVariant: "BlockButton",
                  socialButtonsPlacement: "bottom",
                },
              }}
            />
          </div>
        </div>
      </div>


{/* footer */}
      <footer className="z-10 text-center text-gray-600 text-sm py-6 px-4">
        &copy;BlockBallot. All Rights Reserved.
      </footer>
    </div>
  );
}

export default SigninPage;
